import { Reveal, RevealWords } from "./Motion";

const STEPS = [
  {
    n: "01",
    title: "Strategie",
    desc: "Wir analysieren Markt, Ziele und Zielgruppe. Daraus entsteht ein klarer Plan für Website und Ads.",
  },
  {
    n: "02",
    title: "Design",
    desc: "Individuelles, conversion-orientiertes Design deiner Marke, bis ins letzte Pixel abgestimmt.",
  },
  {
    n: "03",
    title: "Entwicklung",
    desc: "Wir bauen deine Website schnell, sauber und für Google optimiert. Bereit zum Launch.",
  },
  {
    n: "04",
    title: "Launch & Ads",
    desc: "Go-live plus laufende Google-Ads-Kampagnen: wir bringen die Kunden, du bekommst die Aufträge.",
  },
];

export default function Process() {
  return (
    <section id="prozess" className="mx-auto max-w-[1360px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-16">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-[#2c3bff]">/ Unser Prozess</p>
        <h2 className="max-w-2xl font-display text-4xl leading-[0.95] text-ink sm:text-5xl md:text-6xl">
          <RevealWords text="Von der Idee zum Ergebnis." />
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div
              data-testid={`process-step-${s.n}`}
              className="group relative h-full rounded-2xl border border-black/10 bg-white p-7 transition-colors duration-500 hover:border-ink md:p-8"
            >
              <span className="font-display text-6xl text-[#e7e1d4] transition-colors duration-500 group-hover:text-[#2c3bff] md:text-7xl">
                {s.n}
              </span>
              <h3 className="mt-5 font-display text-2xl text-ink">{s.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#565149]">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
